import { ABOUT_IMG } from "./data";
import { Chapter, Rise } from "./motion";

const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="border-b-2 border-ink bg-paper"
  >
    <div className="mx-auto grid max-w-[1500px] grid-cols-1 gap-14 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:py-28">
      <div>
        <Rise>
          <Chapter num="03" label="About Oliver's" />
        </Rise>
        <Rise delay={0.1}>
          <h2 className="mt-6 font-display text-[11vw] uppercase leading-[0.88] sm:text-7xl lg:text-8xl">
            Not your average{" "}
            <span className="text-rust">barbershop.</span>
          </h2>
        </Rise>
        <Rise delay={0.2}>
          <p
            data-testid="about-copy"
            className="mt-8 max-w-lg text-lg font-medium leading-relaxed text-ink/80"
          >
            Oliver&rsquo;s Barber Shop is about good cuts, good conversation and
            leaving the chair feeling fresh. From sharp fades to classic cuts,
            we keep things simple — quality work, proper service and no
            unnecessary bullshit.
          </p>
        </Rise>
        <Rise delay={0.3}>
          <p className="mt-5 max-w-lg text-lg font-medium leading-relaxed text-ink/80">
            Fourteen years on Fitzroy St, St Kilda. Same chair-side honesty,
            same standard. Come as you are.
          </p>
        </Rise>
        <Rise delay={0.4}>
          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 font-hand text-2xl text-ink">
            <span className="-rotate-2">Good people</span>
            <span className="rotate-1 text-rust">Good cuts</span>
            <span className="-rotate-1 text-polered">No BS</span>
          </div>
        </Rise>
      </div>

      <Rise delay={0.2} className="relative">
        <div className="relative rotate-1">
          <div className="tape -top-3 left-1/2 z-10 -translate-x-1/2 -rotate-3" />
          <div className="overflow-hidden border-2 border-ink shadow-hard">
            <img
              src={ABOUT_IMG}
              alt="Inside Oliver's Barber Shop in St Kilda"
              data-testid="about-image"
              className="grit h-[420px] w-full object-cover sm:h-[560px]"
              loading="lazy"
            />
          </div>
          <span className="absolute -left-3 -top-5 z-10 -rotate-3 border-2 border-ink bg-polered px-4 py-2 font-hand text-lg text-paper shadow-hard-sm sm:-left-6">
            A St Kilda institution
          </span>
          <span className="absolute -bottom-4 -right-3 rotate-6 border-2 border-ink bg-rust px-4 py-2 font-hand text-xl text-paper shadow-hard-sm">
            Since 2012
          </span>
        </div>
      </Rise>
    </div>
  </section>
);

export default About;
